<template>
  <div id="app">
    <div id="nav">
      <router-link to="/" class="nav__home"></router-link>
      <router-link to="/about" class="nav__about"></router-link>
      <div v-if="this.$store.getters.getUser.mail">
        <router-link to="/profile" class="nav__profile"></router-link>
        <router-link v-if="this.$store.getters.getKey" to="/account" class="nav__vault"></router-link>
      </div>
      <div v-if="!this.$store.getters.getUser.mail">
        <router-link to="/login" class="nav__profile"></router-link>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  data () {
    return {
      mail: ''
    }
  },
  async created () {
    window.$ = require('jquery')
    window.JQuery = require('jquery')
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
    }
  }
}
</script>

<style lang="scss">

* {
  margin: 0;
  padding: 0;
  font-family: poppins;
  text-decoration: none;
  background-color: transparent;
}

#app {
  background-color: #efeeee;
  min-height: 100vh;
  position: fixed;
  width: 100vw;
}

#nav {
  width: 100vw;
  height: 10vh;
  display: flex;
  justify-content: center;
  align-items: center;
  list-style-type: none;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #efeeee;
  z-index: 10;

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    list-style-type: none;
  }

  .nav__home {
    background-image: url(./assets/home.svg)
  }

  .nav__about {
    background-image: url(./assets/about.svg)
  }

  .nav__profile {
    background-image: url(./assets/profile.svg)
  }

  .nav__vault {
    background-image: url(./assets/shield.svg)
  }

  a, input {

    width: 50px;
    padding-top: 50px;
    margin: 0 0.75em;
    background-size: 32px;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;

    &:hover {
    }

    &.router-link-exact-active {
      border-radius: 50%;
      border: 2px solid #3ad29f;
    }
  }
}

.container-back {
  position: absolute;
  bottom: 20px;
  left: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.container-back-svg {
  background-size: 16px;
  background-position: center;
  background-repeat: no-repeat;
  width: 32px;
  height: 48px;
  background-image: url('./assets/expand.svg');
  transform: rotate(90deg);
}

.container-back-span {
  color: #4caf50;
  cursor: pointer;
}

@import url('https://fonts.googleapis.com/css?family=Poppins&display=swap');

*
{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
body, html
{
    height: 100%;
    font-family: 'Poppins' sans-serif;
}
input
{
    outline: none;
    border: none;
}
input:focus
{
    border-color: transparent !important;
}
input:-internal-autofill-selected {
    background-color: #efeeee !important;
}

input:focus::-webkit-input-placeholder
{
    color: transparent !important;
}
input::-webkit-input-placeholder
{
    color: #adadad;
}
.limiter
{
    width: 100%;
    margin: 0 auto;
}
.container-login
{
    width: 100%;
    min-height: 90vh;
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: #efeeee;
}
.wrap-login
{
    width: 350px;
    background: #efeeee;
    border-radius: 10px;
    overflow: hidden;
    padding: 66px 55px 33px 55px;
}

.login-form
{
    width: 100%;
}
.login-form-title
{
    display: block;
    font-family: 'Poppins';
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    line-height: 1.2;
    text-align: center;
    padding-bottom: 60px;

    p {
      font-size: 20px;
      font-weight: lighter;
    }
}

.wrap-input
{
    width: 100%;
    position: relative;
    border-bottom: 2px solid #adadad;
    margin-bottom: 38px;
}
.input
{
    font-family: 'Poppins';
    font-size: 15px;
    color: #4caf50;
    line-height: 1.2;
    display: block;
    width: 94%;
    height: 45px;
    background: transparent;
    padding: 0 5px;
}
.focus-input
{
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    top:0;
    left: 0;
    pointer-events: none;
}
.focus-input:before
{
    content: "";
    position: absolute;
    display: block;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 2px;
    background: #4caf50;
    transition: all 0.4s;

}

.focus-input:after
{
    font-family: 'Poppins';
    font-size: 15px;
    color:#999999;
    line-height: 1.2;
    content: attr(data-placeholder);
    display: block;
    width: 100%;
    position:absolute;
    top: 16px;
    left: 0px;
    padding-left: 5px;
    transition: all 0.4s;
    -webkit-transition: all 0.4s;
}
.input:focus + .focus-input:after
{
    top: -15px;
}
.input:focus + .focus-input:before
{
    width: 100%;
}

.has-val.input + .focus-input::after
{
    top: -15px;
}
.has-val.input:focus + .focus-input:before
{
    width: 100%;
}

.btn-show-pass
{
    font-size: 15px;
    color:#999999;
    display: -webkit-flex;
    display: -webkit-box;
    display: flex;
    align-items: center;
    position: absolute;
    height: 100%;
    top: 0;
    right: 0;
    padding-right: 5px;
    cursor: pointer;
    transition: all 0.4s;
}

.btn-show-pass:hover
{
    color:#4caf50;
}

.btn-show-pass:active
{
    color:#4caf50;
}
button
{
    outline: none !important;
    border:none;
    background: transparent;
}
.txt1
{
    font-family: 'Poppins';
    font-size: 13px;
    color: #666666;
    line-height: 1.5;
    text-align: center;
}
.warning {
  color: #ca2a2a;
}
.txt2
{
    font-family: 'Poppins';
    font-size: 13px;
    color: #333333;
    line-height: 1.5;
    text-decoration: none;
    transition: all 0.4s;
}
.txt2:hover
{
    text-decoration: underline;
}

.container-login-form-btn
{
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding-top: 20px;
}
.wrap-login-form-btn
{
    width:100%;
    display:block;
    position: relative;
    z-index: 1;
    border-radius: 25px;
    overflow: hidden;
    margin: 0 auto;
    box-shadow: 0 0 3px 3px #efeeee,
                4px 4px 6px 2px rgba(136,136,136,0.7),
                -4px -4px 6px 2px rgba(244,244,244,0.7);

}
.login-form-btn
{
    font-family: 'Poppins';
    font-size: 15px;
    color: #4caf50;
    line-height: 1.2;
    font-weight: bold;
    text-transform: uppercase;
    display: -webkit-flex;
    display: -webkit-box;
    display: flex;
    justify-content: center;
    align-items: center;
    letter-spacing: 1px;
    padding:0 20px;
    height: 50px;
    width:100%;
    cursor: pointer;
}

.login-form-btn:hover
{
    background: #4caf50;
    color:#efeeee;
}
.login-form-btn:active
{
    background: rgb(255,145,19);
    color:#efeeee;
}
.text-center
{
    text-align: center;
    padding-top: 70px;
}

@media screen and (max-height: 700px) {
  .text-center
  {
    padding-top: 20px;
  }
}
.validate-input
{
    position: relative;
}

.alert-validate:before
{
    content: attr(data-validate);
    position: absolute;
    max-width:70%;
    background-color: #fff;
    border-radius: 2px;
    border: 1px solid #c80000;
    padding: 4px 25px 4px 10px;
    top: 50%;
    transform: translateY(-50%);
    right:0px;
    pointer-events: none;
    font-family: 'Poppins';
    color: #c80000;
    font-size: 13px;
    line-height: 1.4;
    text-align: left;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.4s;

}

.alert-validate:after
{
    content: "\f1f8";
    font-family:material-design-iconic-font;
    font-size: 21px;
    color: #c80000;
    position:absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 5px;
}

.alert-validate:hover:before
{
    visibility: visible;
    opacity: 1;

}

/*--Responsive-----*/

@media (max-width: 576px)
{
    .wrap-login
    {
        padding:50px 15px 33px 15px;
    }
}

@media (max-width: 992px){
.alert-validate:hover:before
{
    visibility: visible;
    opacity: 1;

}

}

</style>
